import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import { avaliarProjeto } from '../../store/modules/ProjetoActions';
import { Col } from '../Col';
import { CustomButton } from '../CustomButton';
import { CustomTextArea } from '../CustomTextArea';
import { GenericModal } from '../GenericModal';
import { Row } from '../Row';
import styles from './EvaluationModal.scss';
import { closeModal } from '../../store/modules/ModalActions';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;

export const APPROVE_ACTION = 'APPROVE_ACTION';
export const DISAPPROVE_ACTION = 'DISAPPROVE_ACTION';

const INITIAL_STATE = {
  textChanged: false,
  text: '',
  sending: false,
};

class EvaluationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.toSubmit = this.toSubmit.bind(this);
  }

  getTitle() {
    switch (this.props.action) {
      case APPROVE_ACTION:
        return (
          <>
            {this.props.languageValues.modalApproveTitle}:<br />
            <small>{this.props.title}</small>
          </>
        );
      case DISAPPROVE_ACTION:
        return (
          <>
            {this.props.languageValues.modalDisapproveTitle}:<br />
            <small>{this.props.title}</small>
          </>
        );
      default:
        return '';
    }
  }

  textIsValid() {
    if (this.props.action === DISAPPROVE_ACTION) {
      return this.state.text.length > 0 ? true : false;
    }
    return true;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  toSubmit() {
    this.changeSendingStatus(true);
    this.props.avaliarProjeto(
      this.props.projeto.id,
      this.state.text,
      this.props.auth.userData.id,
      this.props.auth.userData.nome,
      this.props.stepIndex,
      this.props.action === APPROVE_ACTION
        ? PROJECT_STATUS_APROVADO
        : PROJECT_STATUS_REJEITADO,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message:
            this.props.action === APPROVE_ACTION
              ? this.props.languageValues.successAprovacao
              : this.props.languageValues.successReprovacao,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.toClose();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            (this.props.action === APPROVE_ACTION
              ? this.props.languageValues.errorAprovacao
              : this.props.languageValues.errorReprovacao),
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  getActionButton() {
    switch (this.props.action) {
      case APPROVE_ACTION:
        return (
          <CustomButton
            label={this.props.languageValues.approveButton}
            onClick={this.toSubmit}
          />
        );
      case DISAPPROVE_ACTION:
        return (
          <CustomButton
            theme='error'
            label={this.props.languageValues.disapproveButton}
            disabled={!this.textIsValid()}
            onClick={this.toSubmit}
          />
        );
      default:
        return '';
    }
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  render() {
    return (
      <GenericModal
        onClose={() => {
          this.toClose();
        }}
        title={this.getTitle()}
        footerContent={
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-action-buttons'}
            >
              {this.getActionButton()}
            </Col>
          </Row>
        }
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextArea
              label={this.props.languageValues.evaluationTextLabel}
              value={this.state.text}
              onChange={(event) => {
                this.setState({
                  ...this.state,
                  textChanged: true,
                  text: event.target.value,
                });
              }}
              error={this.state.textChanged && !this.textIsValid()}
              counter={true}
              maxSize={2000}
            />
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

EvaluationModal.propTypes = {
  action: PropTypes.oneOf([APPROVE_ACTION, DISAPPROVE_ACTION]).isRequired,
  stepIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  modalKey: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      avaliarProjeto,
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationModal);
